import { globalConst as native, modulesName } from '../../lib/const'

export default {
  install: function (Vue, options) {
    Vue.prototype.native = native
    Vue.prototype.modulesName = modulesName
  }
}